import type { Configuration } from '@setplex/pureya'

import { useUnit } from 'effector-react'
import { useMemo } from 'react'
import { cmcdFeatureModel } from '~/features/cmcd'

/**
 * CMCD configuration hook
 */
export function useCmcd(contentId: string): Configuration['cmcd'] {
  const enabled = useUnit(cmcdFeatureModel.$enabled)

  const cmcd = useMemo(
    () => ({
      enabled,
      useHeader: false,
      cid: contentId,
    }),
    [enabled, contentId]
  )

  return cmcd
}
